// extracted by mini-css-extract-plugin
export default {"productItem_price":"Price_productItem_price__w8qHJ","quontityText":"Price_quontityText__+wJnu","last":"Price_last__Odca2"};